import coreLogger from '../utils/log/coreLogger';

const typeSymbol = Symbol('type');

export default class Action {
  static allowClass: boolean;

  static [typeSymbol]: string;

  static set type(type) {
    Object.defineProperty(this, typeSymbol, { value: type, configurable: true });
  }

  static get type() {
    if (process.env.NODE_ENV !== 'production' && !this.allowClass) {
      const { name } = this;
      const fnName = name.substr(0, 1).toLocaleLowerCase() + name.substr(1);
      coreLogger.warn(`Please use "${fnName}.type" instead of "${name}.type". Class actions are now deprecated.`);
    }

    return this[typeSymbol];
  }

  type: string;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  constructor(...args: unknown[]) {
    if (process.env.NODE_ENV !== 'production' && !(this.constructor as typeof Action).allowClass) {
      const { name } = this.constructor;
      const fnName = name.substr(0, 1).toLocaleLowerCase() + name.substr(1);
      coreLogger.warn(`Please use "${fnName}" instead of "${name}". Class actions are now deprecated.`);
    }
  }
}
